/**
 * «⬇ Выгрузить отчёт» — `#exportBtn` (ui-blocks.md §6.4).
 *
 * `GET /api/reports/summary.xlsx` с параметрами текущего периода.
 * На время запроса кнопка `disabled`. Доступ — только главврач,
 * поэтому кнопку рисует родитель только для роли `chief`.
 */

import { useState } from 'react';
import { errorMessage } from '@/components/ErrorState';
import { downloadReport } from './api';
import type { PeriodValue, ShowToast } from './types';

interface Props {
    period: PeriodValue;
    toast: ShowToast;
}

export function ExportButton({ period, toast }: Props) {
    const [busy, setBusy] = useState(false);

    const run = (): void => {
        if (busy) return;
        setBusy(true);
        downloadReport(period)
            .then(() => {
                toast('Отчёт выгружен');
            })
            .catch((error: unknown) => {
                toast(errorMessage(error) || 'Не удалось выгрузить отчёт');
            })
            .finally(() => {
                setBusy(false);
            });
    };

    return (
        <button type="button" className="act-btn" id="exportBtn" disabled={busy} onClick={run}>
            ⬇ Выгрузить отчёт
        </button>
    );
}
